import axios from "axios";

const API_URL = process.env.REACT_APP_BASE_URL;

export async function updateTicketOwnerSaleItem({
  saleItemId,
  storeId,
  token,
  type,
  name,
  studentId,
}) {
  const url = `${API_URL}/sale-items/update-ticket-owner-sale-item/${saleItemId}/store/${storeId}`;

  const response = await axios.put(
    url,
    {
      type,
      name,
      studentId: type === "student" ? studentId : undefined,
    },
    {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      validateStatus: () => true,
    }
  );

  if (response.status !== 200) {
    throw new Error(
      response.data?.error?.message || "Erro ao salvar destinatário"
    );
  }

  return response.data;
}